namespace Nobox.Nobox {
    export interface StatistikRequest {
        CampaigId?: number;
        CampaignResultId?: number;
        SenderAccountId?: number;
        Status?: string;
        Note?: string;
    }
}
